import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { RequestStatus } from "../../../model/ServiceRequestStatus.model"
import { getUserSalesRoles } from "../../../services/Taxonomy/UserRoles.api";
import { SPA_ADMIN_ROLE, SPA_DRI_ROLE, SPA_REVIEWER_ROLE } from "../SPAConstants";

export interface SystemUserDetail {
    fullname: string | undefined
    domainname: string | undefined
    areas: string[]
}

export interface UserRolesState {
    userDetails: SystemUserDetail,
    isApprover: boolean,
    isSpaUser: boolean,
    isSpaAdmin: boolean,
    isSpaAreaPickerOpen: boolean,
    requestStatus: RequestStatus,
    error: string | undefined
}

const initialState: UserRolesState = {
    userDetails: {
        fullname: undefined,
        domainname: undefined,
        areas: []
    },
    isSpaAreaPickerOpen: false,
    isApprover: false,
    isSpaUser: false,
    isSpaAdmin: false,
    requestStatus: RequestStatus.idle,
    error: undefined
}

export const UserSalesRolesSlice = createSlice({
    name: 'userRole',
    initialState,
    reducers: {
        setIsApproverStatus: (state, action: PayloadAction<boolean>) => {
            state.isApprover = action.payload;
        },
        setIsSpaUser: (state, action: PayloadAction<boolean>) => {
            state.isSpaUser = action.payload;
        },
        setIsSpaAreaPickerOpen: (state, action: PayloadAction<boolean>) => {
            state.isSpaAreaPickerOpen = action.payload;
        },
        setIsSpaAdmin: (state, action: PayloadAction<boolean>) => {
            state.isSpaAdmin = state.isSpaAdmin || action.payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getUserSalesRoles.pending, (state, _) => {
                state.requestStatus = RequestStatus.loading;
                state.error = undefined;
            })
            .addCase(getUserSalesRoles.fulfilled, (state, action) => {
                const areaPayload = action.payload["aspa_userSettings"] || {};
                const userSalesRoles = {
                    fullname: action.payload["fullname"],
                    domainname: action.payload["domainname"],
                    areas: (areaPayload["ASPAArea"] || [])
                } as SystemUserDetail;
                localStorage.setItem('userSalesRoles', JSON.stringify(userSalesRoles));
                state.userDetails = userSalesRoles;
                state.isApprover = (action.payload["securityRoles"] || []).includes(SPA_REVIEWER_ROLE);
                state.isSpaUser = (action.payload["securityRoles"] || []).includes(SPA_DRI_ROLE);
                state.isSpaAdmin = state.isSpaAdmin || (action.payload["securityRoles"] || []).includes(SPA_ADMIN_ROLE);
                state.requestStatus = RequestStatus.succeeded;
                state.error = undefined;
            })
            .addCase(getUserSalesRoles.rejected, (state, action) => {
                state.requestStatus = RequestStatus.failed;
                state.error = action.error.message || state.error;
            })
    }
});

export const {
    setIsApproverStatus,
    setIsSpaUser,
    setIsSpaAdmin,
    setIsSpaAreaPickerOpen
} = UserSalesRolesSlice.actions;

export const UserSalesRolesReducer = UserSalesRolesSlice.reducer